import apiService from "../common/utils/apiService";
import * as filtersActions from "../slices/filtersSlice";

const INDEX_URL = `/index`;

/* To communicate with the geodata-index-server (non-STAC endpoints) */

export const getCollectionStatsSearch = ({ collectionIDs, aoi, bbox, datetimeGTE, datetimeLTE }) => async (dispatch) => {
  if (!collectionIDs || collectionIDs.length === 0) return;
  dispatch(filtersActions.getCollectionStatsRequest());
  try {
    const url = `${INDEX_URL}/stats/search`;
    const body = { collectionIDs };
    if (aoi) {
      body.aoi = aoi;
    } else if (bbox) {
      body.bbox = bbox;
    }
    if (datetimeGTE) body.datetimeGTE = datetimeGTE;
    if (datetimeLTE) body.datetimeLTE = datetimeLTE;
    const response = await apiService.post(url, body, {}, true);
    dispatch(filtersActions.getCollectionStatsSuccess(response));
  }
  catch (error) {
    dispatch(filtersActions.getCollectionStatsFailure(error));
    console.error('Error while getting collection stats search:', error);
  }
};
